module.exports = __webpack_public_path__ + "img/setting_05.943f824b.png";